const CwStore = {
  namespaced: true,
  state: {
    resps: {},
    ls: []
  },
  getters: {
    RESPS: state => {
      return state.resps;
    },
    // LS_BY_CWID_NEW: state => id => {
    //   return state.resps.filter(a => a.cwid == id);
    // },
    LS_BY_CWID: state => id => {
      return state.ls.filter(a => a.id == id);
      // return state.resps.hasOwnProperty(id) ? state.resps[id] : [];
    }
    // LS_BY_CWID: state => id => {
    //   return state.resps.hasOwnProperty(id) ? state.resps[id] : [];
    // }
  },
  mutations: {
    // PROC_RESP_OLD: (state, pld) => {
    //   let stat = pld.stat;
    //   let body = pld.body;
    //   let reqId = pld.reqId;
    //   let id = pld.id;
    //   let isNew = pld.isNew;
    //   let dNew = pld;
    //   // if (pld.hasOwnProperty("actId")) dNew.actId = pld.actId;
    //   dNew.epoch = Date.now();
    //   console.log("EVT: " + JSON.stringify(dNew));
    //   if (!state.resps.hasOwnProperty(id)) {
    //     state.resps[id] = [];
    //   }
    //   let cwOld = [...state.resps[id]];
    //   cwOld.push(dNew);
    //   state.resps[id] = cwOld;
    // },
    PROC_RESP: (state, pld) => {
      // let stat = pld.stat;
      // let body = pld.body;
      // let reqId = pld.reqId;
      // let id = pld.id;
      // let isNew = pld.isNew;
      let dNew = pld;
      dNew.epoch = Date.now();
      // console.log("EVT: " + JSON.stringify(dNew));
      state.ls = [...state.ls, pld];
      // if (!state.resps.hasOwnProperty(id)) {
      //   state.resps[id] = [];
      // }
      // let cwOld = [...state.resps[id]];
      // cwOld.push(dNew);
      // state.resps[id] = cwOld;
      // let cwOld = JSON.parse(JSON.stringify(state.resps[id]));
      // cwOld.push(dNew);
      // state.resps[id] = cwOld;
    },
    CLEAR: state => {
      state.resps = {};
      state.ls = [];
    }
  },
  actions: {
    procEvt: async ({ commit }, pld) => {
      commit("PROC_RESP", pld);
    }
  }
  // actions: {
  //   INITNEWRESPS: ({ commit, state, dispatch }, pld) => {
  //     for (const cwid in pld.d) {
  //       let reqId = "" + pld.d[cwid];
  //       commit("PROC_RESP", {
  //         id: cwid,
  //         actId: pld.actId,
  //         reqId: reqId,
  //         stat: 0,
  //         tx1: "",
  //         isNew: true
  //       });
  //     }
  //   }
  // }
};

export default CwStore;
